import { guideSteps } from "@/mocks/observeData";
import { SectionHeading, SectionShell } from "./common";

export default function GuideSection() {
  return (
    <SectionShell id="guide" className="relative bg-background-50 py-14 md:py-20">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-secondary-300 to-transparent" />
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.35fr] lg:gap-14">
        <div className="flex flex-col justify-center">
          <SectionHeading
            eyebrow="HOW WE WORK"
            title="面对一条‘黑料’，我们怎么核实"
            desc="网络传闻扩散速度远超事实。我们把这套信源核查方法写出来，既是自己的编辑准则，也希望你能用同样的眼光看待每一条待验证的信息。"
          />
          <p className="mt-6 rounded-lg border-l-4 border-primary-500 bg-primary-50 p-4 text-sm leading-relaxed text-primary-900">
            <span className="font-bold">记忆：</span>
            没有出处的“猛料”，价值约等于零。先看信源，再谈情绪。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {guideSteps.map((s, i) => (
            <div key={s.no} className="relative flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5">
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${s.icon} text-2xl`} />
                </span>
                <span className="font-heading text-4xl font-black text-secondary-200">{s.no}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              {i < guideSteps.length - 1 && (
                <i className="ri-arrow-down-line absolute -bottom-2 left-1/2 z-10 hidden -translate-x-1/2 text-secondary-400 sm:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}